
export default {
    data() {
        return {
            nav: 0,
            source: '',
            currentPage: 1,
            video: 1,
            scrollTop: ''
        }
    },
    head() {
        // 优化seo：动态设置title，keywords 和 description
        return {
            title: 'courses',
            meta: [
                {
                    name: "keywords",
                    content:
                        "courses",
                },
                {
                    hid: 'description', name: 'names', content: 'courses'
                },
            ],
        };
    },
    mounted() {
        this.parametricWork()
        window.addEventListener('scroll', this.handleScroll, true)
    },
    methods: {
        // 作品方法
        async parametricWork(page = 1) {
            let res = await this.$global.parametricWork({ "activityId": 13, "page": page, "award": 0 })
            console.log(res);
            // res.code = '200' ? (this.source = res.result) : []
            this.source = res
        },
        // 分页
        handleCurrentChange(val) {
            this.currentPage = val
            this.parametricWork(this.currentPage)
        },
        handleScroll() {
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        },
    },
}
